import { utilBuildings } from "../../../utils/utilBuildings";
import { selectBuildingDecorationsAvailable } from "./selectBuildingDecorationsAvailable";
export var selectBuildingDecorationConstructionDone = function (state) {
    var availableDecorationBuildings = selectBuildingDecorationsAvailable(state);
    return availableDecorationBuildings.filter(utilBuildings.hasFinishedConstruction);
};



//////////////////
// WEBPACK FOOTER
// ./src/features/show-me/selectors/selectBuildingDecorationConstructionDone.ts
// module id = 902
// module chunks = 3